import React, { useState } from 'react';
import EvaluationSubmission from 'models/EvaluationSubmission';
import TeacherGradebook from 'models/TeacherGradebook';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap, faTrash } from '@fortawesome/free-solid-svg-icons';
import EvaluationSubmissionRow from './EvaluationSubmissionRow';
import Evaluation from 'models/Evaluation';
import { EVALUATION_DISPLAY_NAMES } from 'utils/types';
import IconButton from 'view/components/buttons/IconButton';
import useApiCall from 'contexts/ApiCall';
import evaluationService from 'services/evaluationService';
import { useGradebook } from 'contexts/TeacherGradebookContext';

interface EvaluationSubmissionsProps {
  evaluation: Evaluation;
  gradebook: TeacherGradebook;
  onUpdateEvaluationSubmission: (
    assignment: EvaluationSubmission,
    field: string,
    value: any,
  ) => void;
  onClose: () => void;
}

export const EvaluationSubmissions: React.FC<EvaluationSubmissionsProps> = ({
  evaluation,
  gradebook,
  onUpdateEvaluationSubmission,
  onClose,
}) => {
  const [selectedSubmission, setSelectedSubmission] = useState<string>();
  const { setGradebook } = useGradebook();
  const makeApiCall = useApiCall();

  const handleDeleteEvaluation = () => {
    makeApiCall(evaluationService.deleteEvaluation, evaluation.id)
      .then((resp) => {
        // delete the evaluation from the gradebook
        setGradebook((prev) => prev?.removeEvaluation(evaluation));
        alert('Evaluation successfully deleted!');
        onClose();
      })
      .catch((error) =>
        alert(
          'Failed to delete the evaluation, please reach out to support@oratorlearning.us if the problem persists',
        ),
      );
  };

  return (
    <div className="student-details">
      <div className="student-details-header">
        <div className="row spaced">
          <div className="row">
            <FontAwesomeIcon
              icon={faGraduationCap}
              size="xl"
              color="var(--pure-white)"
            />
            <label className="label-large">
              {EVALUATION_DISPLAY_NAMES[evaluation.type]} Evaluation
            </label>
          </div>
          <IconButton
            type="transparent"
            icon={faTrash}
            color="var(--pure-white)"
            requiresConfirmation={true}
            confirmationMessage="You are about to delete an evaluation, permanently deleting all submissions and associated data."
            onClick={handleDeleteEvaluation}
          />
        </div>
      </div>
      <div className="student-details-content">
        {gradebook.evaluations.submissions[evaluation.id]?.map((submission) => {
          // get the student
          const student = gradebook.students.find(
            (s) => s.user_id === submission.user,
          );
          if (!student) return null;
          return (
            <EvaluationSubmissionRow
              key={`student-evaluation-row-${student.displayName()}`}
              label={student.displayName()}
              evaluationSubmission={submission}
              evaluation={evaluation}
              selected={selectedSubmission === submission.id}
              setSelected={setSelectedSubmission}
              onUpdateEvaluationSubmission={onUpdateEvaluationSubmission}
            />
          );
        })}
      </div>
    </div>
  );
};

export default EvaluationSubmissions;
